<app-header></app-header>

<div class="container-fluid" style="width: 80%; min-height: 600px">

    <div class="row mt-4 mb-4">
        <div class="col">
            <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
                <ol class="breadcrumb mb-0 p-0">
                    <li class="breadcrumb-item"><a href="/home">Home</a><span class="separator">/</span></li>
                    <li class="breadcrumb-item active" aria-current="page">Punti di erogazione 2</li>
                </ol>
            </nav>
        </div>
    </div>

    <div class="row mt-4 mb-4">
        <div class="col">
            <h4>Punti di erogazione 2</h4>
        </div>
    </div>

    <mat-card class="p-2" appearance="outlined">
        <mat-card-content>
            @if (caricamento) {
                <div class="text-center py-4">
                    <mat-spinner diameter="40"></mat-spinner>
                    <p class="mt-2 mb-0">Caricamento strutture...</p>
                </div>
            } @else if (errore) {
                <p class="text-danger">{{ errore }}</p>
            } @else {
                <p class="mb-3"><b>Elenco strutture</b> ({{ strutture.length }})</p>
                <mat-form-field class="w-100 mb-2">
                    <mat-label>Cerca strutture</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Id, codice o denominazione" #input>
                </mat-form-field>
                <table mat-table [dataSource]="dataSource" class="w-100">
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef>Id</th>
                        <td mat-cell *matCellDef="let s">{{ s.id }}</td>
                    </ng-container>
                    <ng-container matColumnDef="codice">
                        <th mat-header-cell *matHeaderCellDef>Codice</th>
                        <td mat-cell *matCellDef="let s">{{ s.codice }}</td>
                    </ng-container>
                    <ng-container matColumnDef="denominazione">
                        <th mat-header-cell *matHeaderCellDef>Denominazione</th>
                        <td mat-cell *matCellDef="let s">{{ s.denominazione }}</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="goToDettaglio(row.id)" class="clickable-row"></tr>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                            Nessun dato trovato per "{{ input.value }}"
                        </td>
                    </tr>
                </table>
                <mat-paginator [pageSizeOptions]="[5, 10, 20, 50]" showFirstLastButtons
                    aria-label="Seleziona pagina strutture">
                </mat-paginator>
            }
        </mat-card-content>
    </mat-card>

</div>

<app-footer></app-footer>
